import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons'
import fastTrack from '../../assets/images/fasttrack.png'
import greentick from '../../assets/images/green_tick.svg'
import {
	getWeightUnit,
	WEIGHT_UNIT,
	getDecimalFormattedNumber,
} from '../../constants'
import './fasttrack.scss'
import FlightDetails from '../FlightDetails'
import { Trans, useTranslation } from 'react-i18next'
import Messages from '../../constants/Messages'
import getCurrentUser from '../../utils/getCurrentUser'
import rightArrow from '../../assets/images/right-arrow-blue.png'

const FastTrack = ({
	setEnquiredPresent,
	fastTrackList,
	fasttrackLowestRate,
	fasterToDefaultByMin,
	setFastTrackEnabled,
    onFastTrackUpgrade,      
    onFastTrackRemove
}) => {
	const [isFastTrackExpanded, setFastTrackExpanded] = useState(false)
	const [diffDays, setDiffDays] = useState(0)
	const [diffHrs, setDiffHrs] = useState(0)
	const [diffMins, setDiffMins] = useState(0)

	const isInterlineAgent = getCurrentUser()?.interlineAgent === 'Y';

	//for multilingual
	const { t, i18n } = useTranslation(['labels', 'errors'])

	const handleUpgrade = () => {
		if (!fastTrackList?.length) return;
		const r = fastTrackList[0]?.ratingDetails?.[0];
		if (!r) return;
		setFastTrackExpanded(true);
		setFastTrackEnabled(true);
		const payload = {
			currency: fasttrackLowestRate?.currency || r.currency || r.currencyCode || '',
			grandTotal: Number(r.grandTotal) || 0,
			totalRate: Number(r.totalRate) || 0
		};
		onFastTrackUpgrade && onFastTrackUpgrade(payload);
	};

	const handleRemove = () => {
		setFastTrackExpanded(false);
		setFastTrackEnabled(false);
		onFastTrackRemove && onFastTrackRemove();
	};

	useEffect(() => {
		const diffDays = fasterToDefaultByMin
			? Math.floor(fasterToDefaultByMin / 60 / 24)
			: 0
		const diffHrs = fasterToDefaultByMin
			? Math.floor((fasterToDefaultByMin / 60) % 24)
			: 0
		const diffMins = fasterToDefaultByMin
			? Math.floor(fasterToDefaultByMin % 60)
			: 0
		setDiffDays(diffDays)
		setDiffHrs(diffHrs)
		setDiffMins(diffMins)
	}, [fastTrackList, fasterToDefaultByMin])
	return (
		<div className='portal-col'>
			<div
				className={`flight-details fasttrack ${isFastTrackExpanded ? 'border-expand' : ''
					}`}
			>
				<div
					className='flight-details__fasttrack__item parent-line'
				// onClick={() => setFastTrackExpanded(!isFastTrackExpanded)}
				>
					<div className='flight-details__fasttrack__item first_row'>
						<div className='flight-details__fasttrack__left'>
							{/* <div className='flight-details__price__service'>
							<img src={fastTrack} alt='fastTrack' title='fastTrack' />
						</div> */}
							<img
								className={`fastrack-logo ${isFastTrackExpanded ? 'small' : 'large'}`}
								src={fastTrack}
								alt='fastTrack'
								title='fastTrack'
							/>
						</div>

						<div className='flight-details__fasttrack__right'>
							{!isFastTrackExpanded ? (
								<>
									<div class='flight-details__fasttrack__price__sub'>
										{fasterToDefaultByMin > 0 ? (
											<div className='fasttrack-label mb-2'>
												<Trans
													i18nKey={t('ER042', {
														diffDays: diffDays ? diffDays + t('COMMON.DAYS') : '',
														diffMins: diffMins
															? (diffDays || diffHrs ? t('COMMON.AND') : '') +
															diffMins +
															t('COMMON.MINUTES')
															: '',
														diffHrs: diffHrs
															? (diffDays && !diffMins ? t('COMMON.AND') : '') +
															diffHrs +
															t('COMMON.HOURS')
															: '',
														ns: 'errors',
													})}
													t={t}
												/>
											</div>
										) : (
											<div className='fasttrack-label'>
												<Trans>
													{t(Messages.FASTTRACK_BANNER_MSG, { ns: 'errors' })}
												</Trans>
											</div>
										)}
										{!isInterlineAgent && <>
											{fastTrackList[0].ratingDetails[0].grandTotal !== 0 ? (
												<div class='flight-details__fasttrack__price__sub__pricing'>
													<div class='flight-details__fasttrack__price__sub__amount'>
														<label className='fasttrack-amount-grant-total'>
															{fasttrackLowestRate.currency}{' '}
															{getDecimalFormattedNumber(fastTrackList[0].ratingDetails[0].grandTotal)}
														</label>
													</div>
													<div className='seperator'> - </div>
													<div class='flight-details__fasttrack__price__sub__rate'>
														<label className='fasttrack-amount-total-rate'>
															{fasttrackLowestRate.currency}{' '}
															{getDecimalFormattedNumber(fastTrackList[0].ratingDetails[0].totalRate)}
															{'/'}
															{getWeightUnit(WEIGHT_UNIT.KILOGRAM)}
														</label>
													</div>
												</div>

											) : (
												<div className='flight-details__fasttrack__no-rate'>
													{t('COMMON.NO_RATES')}
												</div>
											)}
										</>}
										<div class='flight-details__arrowRight d-none d-lg-block' onClick={handleUpgrade} >
											<label className='arrow-label'>Upgrade to FastTrack now</label>
											<i>
												<img className='right-arrow' src={rightArrow} title='rightarrow' />
											</i>

										</div>
									</div>



								</>
							) : (
								<div className='flight-details__upgraded'>
									<div className='flight-details__upgraded__text'>
										<img className='tickicon' src={greentick} alt='close' title='close' />
										<label className='upgraded-label'>Upgraded to Fasttrack</label>
									</div>
									<div class='flight-details__close' >
										<label className='remove-label' onClick={handleRemove}>Remove</label>
									</div>

								</div>
							)}
						</div>
					</div>
					{!isFastTrackExpanded && (
						<div className='flight-details__arrowRight d-flex d-lg-none' onClick={handleUpgrade}>
							<label className='arrow-label'>Upgrade to FastTrack now</label>
							<i>
								<img className='right-arrow' src={rightArrow} title='rightarrow' />
							</i>
						</div>
					)}
				</div>


			</div>
		</div>

	)
}

export default FastTrack
